import Vue from "vue";
import {
  Button,
  Input,
  Form,
  FormItem,
  Loading,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Tabs,
  TabPane,
  Radio,
  RadioGroup,
  Checkbox,
  CheckboxGroup,
  Message,
  Select,
  Option,
  Autocomplete,
  Drawer,
  TimePicker,
  Dialog,
  Avatar,
  Row,
  Col,
  Upload,
  TimeSelect,
  DatePicker,
  TableColumn,
  Pagination,
  MessageBox,
  Switch,
  Notification,
  InputNumber,
  Progress,
  Slider,
  Popover,
  infiniteScroll,
  Tooltip,
  Image,
  Collapse,
  CollapseItem,
  popconfirm,
  Carousel,
  CarouselItem,
  RadioButton,
  Menu,
  MenuItem,
  Submenu,
  cascader,
  Scrollbar,
} from "element-ui";

import '@/utils/proxyElTable'

const _Loading = Loading
const _MessageBox = MessageBox
const { directive: loadingDirective, service: loadingService } = _Loading
Vue.use(infiniteScroll)
Vue.use(Button)

Vue.use(DatePicker)
Vue.use(Input)
Vue.use(popconfirm)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Autocomplete)
Vue.use(Select)
Vue.use(Option)
Vue.use(Drawer)
Vue.use(TimePicker)
Vue.use(Dialog)
Vue.use(loadingDirective)
Vue.use(Avatar)
Vue.use(Row).use(Col)
Vue.use(Upload)
Vue.use(TableColumn)
Vue.use(Pagination)
Vue.use(Switch)
Vue.use(InputNumber)
Vue.use(Progress)
Vue.use(Slider)
Vue.use(Popover)
Vue.use(Image)
Vue.use(Tooltip)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(TimeSelect)
Vue.use(Carousel).use(CarouselItem)
Vue.use(RadioButton)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(Submenu)
Vue.use(cascader)
Vue.use(Scrollbar)
Vue.prototype.$globalLoading = loadingService
Vue.prototype.$message = Message
Vue.prototype.$confirm = _MessageBox.confirm
Vue.prototype.$alert = _MessageBox.alert
Vue.prototype.$prompt = _MessageBox.prompt
Vue.prototype.$notify = Notification
